export default __webpack_public_path__ + "static/media/aboutus.89d4b478.svg";